module.exports = "/_next/static/images/avatar_inner-895be6ae01051dc3efe8b631ada3e0d5.jpg";